import { FCX } from "@datassential/platform-ui-lib";
import { useEffect, useMemo } from "react";
import { HomeShow, HomeViewAs } from "@core/constants";
import PeopleViewRawNorm from "@pages/Home/components/PeopleView/PeopleViewRawNorm";
import PeopleViewIndex from "@pages/Home/components/PeopleView/PeopleViewIndex";
import { SelectAmongContextProvider, SelectAmongData } from "@vms/SelectAmong/SelectAmongContext";
import { HOME_PEOPLE_VIEW_INITIAL_RESPONDENT_TYPES } from "@models/RespondentType";
import PeopleViewContextProvider, {
    PeopleViewFilterSortContextProvider,
    usePeopleViewContext
} from "@pages/Home/components/PeopleView/PeopleViewContext";
import { Sort } from "@models";
import HomeActionsBar from "@pages/Home/components/HomeActionsBar/HomeActionsBar";
import { ProfileExportPptRequest } from "@pages/Profile/components/Header/Header";
import { useDisplayMetricContext, useHomeSearchSettingsContext } from "@pages/Home/HomeContext";
import HomeAmongSettingsApplier from "@pages/Home/HomeAmongSettingsApplier";
import { Metric } from "@models/Metric";

const PeopleViewContent: FCX = () => {
    const { show } = usePeopleViewContext();
    const { displayMetricId } = useDisplayMetricContext();

    const exportPayload = useMemo(
        (): ProfileExportPptRequest => {
            if (displayMetricId === null) {
                return {};
            }

            return { trendMetric: displayMetricId as ProfileExportPptRequest['trendMetric'] };
        },
        [displayMetricId]
    );

    return (
        <>
            {show !== HomeShow.Index && <PeopleViewRawNorm/>}
            {show === HomeShow.Index && <PeopleViewIndex/>}
            <HomeActionsBar exportPayload={exportPayload}/>
        </>
    );
}

const PeopleView: FCX = () => {
    const { data, } = useHomeSearchSettingsContext();
    const { setDisplayMetricId } = useDisplayMetricContext();

    useEffect(() => {
        setDisplayMetricId(Metric.KnowIt);
    }, [setDisplayMetricId]);

    useEffect(() => {
        if (data?.displayMetric) {
            setDisplayMetricId(data.displayMetric);
        }
    }, [data, setDisplayMetricId]);

    const amongInitialData = useMemo(
        (): Partial<SelectAmongData> => (data?.among && data?.viewAs === HomeViewAs.People) ? ({
            respondentTypes: data.among.respondentTypes.slice(0, 10),
        }) : ({
            respondentTypes: HOME_PEOPLE_VIEW_INITIAL_RESPONDENT_TYPES,
        }),
        [data]
    );

    return (
        <SelectAmongContextProvider initialData={amongInitialData}>
            <PeopleViewContextProvider>
                <PeopleViewFilterSortContextProvider
                    initialSortingKey="name"
                    initialSortingDirection={Sort.Asc}
                >
                    <PeopleViewContent/>
                    <HomeAmongSettingsApplier/>
                </PeopleViewFilterSortContextProvider>
            </PeopleViewContextProvider>
        </SelectAmongContextProvider>
    );
}

export default PeopleView;